import type { TranslationGetter } from '../../../../types';

export class TranslationService {
  private copies: ReturnType<TranslationService['createCopies']>;

  constructor(private t: TranslationGetter) {
    this.copies = this.createCopies();
  }

  public api() {
    return {};
  }

  public handlers() {
    return {};
  }

  public data() {
    return {
      getFormWidgetCopies: () => this.copies,
    };
  }

  public getCopies() {
    return this.copies;
  }

  private createCopies() {
    const { t } = this;

    return {
      firstName: t('application-layer.billing-info-base.first-name'),
      lastName: t('application-layer.billing-info-base.last-name'),
      phone: t('application-layer.billing-info-base.phone'),
      companyName: t('application-layer.billing-info-base.company-name'),
      companyOrOrganization: t('application-layer.billing-info-base.company-organization'),
      apartmentOrSuite: t('application-layer.billing-info-base.ap-suite'),
      addressLine1: t('application-layer.billing-info-base.address-line1'),
      addressLine2: t('application-layer.billing-info-base.address-line2'),
      city: t('application-layer.billing-info-base.city'),
      state: t('application-layer.billing-info-base.state'),
      selectState: t('application-layer.billing-info-base.select-state'),
      country: t('application-layer.billing-info-base.countries'),
      postalCode: t('application-layer.billing-info-base.postalcode'),
      zipcode: t('application-layer.billing-info-base.zipcode'),
      billingEmail: t('application-layer.billing-info-base.billing-email'),
      selectEmail: t('application-layer.billing-info-base.select-email'),
      typeEmail: t('application-layer.billing-info-base.type-email'),
      optional: t('application-layer.billing-info-base.optional'),
    };
  }
}
